import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;
	gap: 1.5rem;
`;

export const inptus = styled.div`
	width: 100%;
	max-height: 50vh;
	overflow: auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-start;
	gap: 1.5rem;
`;

export const threeItens = styled.div`
	width: 100%;
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	gap: 1rem;

	@media (max-width: 800px) {
		grid-template-columns: 1fr;
	}
`;

export const twoItens = styled.div`
	width: 100%;
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 1rem;

	@media (max-width: 800px) {
		grid-template-columns: 1fr;
	}
`;

export const switchTooggle = styled.div`
	position: relative;
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 0.5rem;

	> p {
		font-weight: 700;
		color: ${color.interface.lightGray};
		font-size: 1.4rem;
	}

	> div {
		width: 100%;
		display: flex;
		align-items: center;
		gap: 1rem;
		justify-content: flex-start;
	}
`;

export const containerBtns = styled.div`
	width: 100%;
	margin-top: 1rem;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 1rem;

	> button {
		all: unset;
		width: fit-content;
		text-align: center;
		border-radius: 5px;
		padding: 1rem 2rem;
		color: ${color.interface.white};
		font-size: 1.3rem;
		cursor: pointer;
	}
`;

export const save = styled.button`
	background-color: ${color.system.success} !important;
`;

export const cancel = styled.button`
	background-color: ${color.system.error} !important;
`;
